import ColumnsStorage from '@@/advertisement/common/ColumnsStorage';

const key = 'advertisement-bids-columns-v1';

export default dynamicColumns => {
  return new ColumnsStorage({
    columns: dynamicColumns,
    keyToStoreWith: key,
  });
};
